export default{
    apiKey: "AIzaSyDrW-rKZM7Dq4PElbePYkyLe6oin9MIAvs",
    authDomain: "webdiesel-7d351.firebaseapp.com",
    databaseURL: "https://webdiesel-7d351.firebaseio.com",
    projectId: "webdiesel-7d351",
    storageBucket: "webdiesel-7d351.appspot.com",
    messagingSenderId: "554167411304",
    appId: "1:554167411304:web:fd76f919b2cd10b12751dd",
    measurementId: "G-WDM125W4XJ"
}